"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.halfToFull = exports.fullToHalf = void 0;
const FULL_ALPHABET = ['Ａ', 'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ', 'Ｎ', 'Ｏ', 'Ｐ', 'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ', 'Ｚ', 'ａ', 'ｂ', 'ｃ', 'ｄ', 'ｅ', 'ｆ', 'ｇ', 'ｈ', 'ｉ', 'ｊ', 'ｋ', 'ｌ', 'ｍ', 'ｎ', 'ｏ', 'ｐ', 'ｑ', 'ｒ', 'ｓ', 'ｔ', 'ｕ', 'ｖ', 'ｗ', 'ｘ', 'ｙ', 'ｚ'];
const HALF_ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
const FULL_NUMBER = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];
const HALF_NUMBER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const FULL_SIGN = ['！', '＃', '＄', '％', '＆', '（', '）', '＊', '＋', '，', '－', '．', '／', '：', '；', '＜', '＝', '＞', '？', '＠', '［', '］', '＾', '＿', '｀', '｛', '｜', '｝', '”', '’', '￥', '～'];
const HALF_SIGN = ['!', '#', '$', '%', '&', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', ']', '^', '_', '`', '{', '|', '}', '"', "'", '\\', '~'];
const FULL_KANA = ['ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'サ', 'シ', 'ス', 'セ', 'ソ', 'タ', 'チ', 'ツ', 'テ', 'ト', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ヨ', 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'ヴ', 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ッ', 'ャ', 'ュ', 'ョ', 'ヮ', 'ヰ', 'ヱ', '・', 'ー', '、', '。', '・', '「', '」'];
const HALF_KANA = ['ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ', 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ', 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ', 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ', 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ﾕ', 'ﾖ', 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ', 'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ', 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ', 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ', 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ', 'ｳﾞ', 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｯ', 'ｬ', 'ｭ', 'ｮ', , , , '･', 'ｰ', '､', '｡', '･', '｢', '｣'];
const FULL_SPACE = ['　'];
const HALF_SPACE = [' '];
const FULL_CHARACTER = [...FULL_ALPHABET, ...FULL_NUMBER, ...FULL_SIGN, ...FULL_SIGN, ...FULL_KANA, ...FULL_SPACE].reduce((s, v, index) => {
    s[index] = v;
    s[v] = index;
    return s;
}, {});
const HALF_CHARACTER = [...HALF_ALPHABET, ...HALF_NUMBER, ...HALF_SIGN, ...HALF_SIGN, ...HALF_KANA, ...HALF_SPACE].reduce((s, v, index) => {
    s[index] = v;
    s[v] = index;
    return s;
}, {});
/**
 *
 * @param {string} fullwidthString
 * @returns {string}
 */
const fullToHalf = (fullwidthString) => {
    return fullwidthString.split('').map(c => {
        const fullIndex = FULL_CHARACTER[c];
        return HALF_CHARACTER[fullIndex] === undefined ? c : HALF_CHARACTER[fullIndex];
    }).join('');
};
exports.fullToHalf = fullToHalf;
/**
 *
 * @param {string} halfWidthString
 * @returns {string}
 */
const halfToFull = (halfWidthString) => {
    return halfWidthString.split('').map(c => {
        const halfIndex = HALF_CHARACTER[c];
        return FULL_CHARACTER[halfIndex] === undefined ? c : FULL_CHARACTER[halfIndex];
    }).join('');
};
exports.halfToFull = halfToFull;
